import EventService from '../../services/EventService';
import {
	PULL_DATA_ERROR,
	PULL_DATA_LOADING,
	PULL_DATA_SUCCESS,
} from '../types';

export const getData = () => {
	return (dispatch) => {
		dispatch({
			type: PULL_DATA_LOADING,
		});

		EventService.getEvents_New()
		.then(res => {
				let data = [];
                res.data.forEach((doc) => {
					const object = doc;
					object.doc = doc.event_id;
					if(object.estado_duplicado === '' || object.estado_duplicado === 'No Duplicado') 
					{
						object.estado_duplicado = null;
					}
					data = [...data, object];
				});
						dispatch({
							type: PULL_DATA_SUCCESS,
							payload: data,
						});
			}).catch((error) => {
				console.log(error);
				dispatch({
					type: PULL_DATA_ERROR,
					payload: error,
				});
				EventService.logError({ message: error.message, stack: error.stack });
			});


	};
};
